import Button from "devextreme-react/button";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { LoadPagePanel } from "../../../../components";
import { AR, FileTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitInstallationPhotos } from "../api/submit-installation-photos";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function SubmitPhotosButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");
	const navigate = useNavigate();
	const location = useLocation();

	const submitPhotos = useSubmitInstallationPhotos(
		order.details.retailOrderID,
		(result) => {
			showSuccessMessage("Photos have been submitted");

			const newActionRequiredID = result.activeARs.find(x => x == 160);
			const to = `/cfi/retail-order/${order.details.retailOrderID}/${newActionRequiredID}` +
				(!!returnUrl ? '?returnUrl=' + returnUrl : '');

			if (newActionRequiredID && location.pathname !== to) {
				navigate(to);
			}
			else {
				refetchOrder();
			}
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-submit-photos' }}
				text="Submit Photos"
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.CfiToUploadInstallationPhotos)}
				disabled={submitPhotos.isLoading}
				onClick={() => {
					if (order.details.files.filter(x => x.fileTypeID === FileTypes.DisplayPhoto).length < 3) {
						showErrorMessage('At least 3 installation photos are required');
					}
					else {
						submitPhotos.mutate();
					}
				}} >
			</Button>
			<LoadPagePanel visible={submitPhotos.isLoading}></LoadPagePanel>
		</>
	)
}
